export const R2_BASE = 'https://pub-8503940bf6d84b34aa39a66c5a07d2ef.r2.dev/soulo'
export const R2_CDN = `${R2_BASE}/chars`

// Keep shared lineup image same-origin to avoid cross-origin SW/CORS failures on some browsers.
export const SHARED_IMG = '/chars/lineup-shared.webp'
export const OG_SHARED = 'https://pub-8503940bf6d84b34aa39a66c5a07d2ef.r2.dev/soulo/chars/lineup-shared.webp'
export const OG_JP = 'https://pub-13bb50bad8eb4a768779abfeefc3e6f2.r2.dev/avatars/jp-shared-avatar.webp'

export const IMAGE_VERSION_MAP = {
  fini: 'v=1',
  rela: 'v=1',
  aven: 'v=1',
  'aven-evangelical': 'v=1',
  'aven-catholic': 'v=1',
  'aven-soka': 'v=1',
  teli: 'v=1',
  movo: 'v=1',
  zelo: 'v=1',
  lumi: 'v=1',
  mira: 'v=1',
  mone: 'v=1',
}

export const CHARACTER_CATALOG = {
  kivo: {
    id: 'kivo',
    displayName: 'Kivo',
    name: 'Kivo',
    emoji: '🚀',
    tier: 2,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Cuts perfectionism, narrows scope, and gets the real thing shipped.',
    voice: 'Sharp, grounded, forward-moving',
    social: '',
    color: '#fb923c',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1f0a00 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Ship This Week with Kivo | Creator Accountability AI | Leka AI',
    seoDescription: 'Kivo helps creators and solopreneurs beat perfectionism, narrow scope, and ship one real thing this week.',
    seoKeywords: 'ship this week, creator accountability AI, beat perfectionism, solopreneur execution, ship faster, creator productivity',
    bio: 'For founders, creators, and solo builders who keep hiding in polishing. Kivo cuts scope and gets the real thing out.',
    role: 'Creator',
    subtitle: 'Ship the real thing',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'kivo-jp': {
    id: 'kivo-jp',
    displayName: 'Kivo',
    name: 'Kivo',
    emoji: '🚀',
    tier: 2,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '完璧主義を切って、スコープを絞り、本物を出荷させる。',
    voice: 'Sharp, grounded, forward-moving',
    social: '',
    color: '#fb923c',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1f0a00 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Kivo | 今週ちゃんと出荷するためのAI | Leka AI',
    seoDescription: 'Kivo は、完璧主義と先延ばしを切って、クリエイターや個人開発者に今週1つを出荷させる AI です。',
    seoKeywords: '今週出荷, 先延ばし, 完璧主義, 個人開発, クリエイター, 実行支援AI, Kivo',
    bio: '作る人のための実行OS。整える前に出す。磨く前に届ける。Kivoはその一歩を切り出す。',
    role: 'Creator',
    subtitle: '本物を出荷する',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  fini: {
    id: 'fini',
    displayName: 'Fini',
    name: 'Fini',
    emoji: '🔥',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Sees through your avoidance. Makes you finish one thing today.',
    voice: 'Direct, warm, relentless',
    social: '',
    color: '#f97316',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0800 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Fini — the internal benchmark for avoidance detection, commitment extraction, and re-entry.',
    bio: 'Fini now serves as the internal benchmark that sharpens the Leka engine before public rollout.',
    role: 'Benchmark',
    subtitle: 'Internal execution benchmark',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'fini-jp': {
    id: 'fini-jp',
    displayName: 'Fini',
    name: 'Fini',
    emoji: '🔥',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '逃げを見抜く。今日やるべき1つを終わらせる。',
    voice: 'Direct, warm, relentless',
    social: '',
    color: '#f97316',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0800 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Fini — 回避検知・コミット抽出・再入場を磨くための内部benchmark。',
    bio: 'Finiは公開の主役ではなく、Leka engine を鍛える内部benchmarkとして残る。',
    role: 'Benchmark',
    subtitle: '内部実行ベンチマーク',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  rela: {
    id: 'rela',
    displayName: 'Rela',
    name: 'Rela',
    emoji: '💜',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Navigates the tangled mess of relationships.',
    voice: 'Warm, perceptive, honest',
    social: '',
    color: '#a855f7',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0020 0%, #0a0008 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Rela — relationship support, retained in the codebase and frozen from the public roster.',
    bio: 'Romantic, family, friends — Rela remains in the codebase, but is frozen from the current public launch.',
    role: 'Relationship',
    subtitle: 'Frozen for now',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'rela-jp': {
    id: 'rela-jp',
    displayName: 'Rela',
    name: 'Rela',
    emoji: '💜',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '人間関係の核心を見つける。',
    voice: 'Warm, perceptive, honest',
    social: '',
    color: '#a855f7',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0020 0%, #0a0008 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Rela — コードベースには残すが、現行公開 roster からは freeze。',
    bio: '恋愛・家族・友人関係の支援役として残すが、今の公開 lineup からは外す。',
    role: 'Relationship',
    subtitle: 'いったん凍結',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  aven: {
    id: 'aven',
    displayName: 'Aven',
    name: 'Aven',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Helps you return to prayer, reflection, and inner-life practice without flattening faith into generic wellness.',
    voice: 'Grounded, gentle, real',
    social: '',
    color: '#60a5fa',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #000a1a 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Aven | Prayer and Inner Life Continuity | Leka AI',
    seoDescription: 'Aven helps you return to prayer, reflection, and inner-life practice with steady continuity, shame-safe re-entry, and room for faith-specific depth.',
    seoKeywords: 'prayer continuity, inner life practice, spiritual re-entry, ritual adherence, reflection habit, Aven',
    bio: 'Aven is Leka’s inner-life surface, built to help you return to prayer, reflection, and grounded practice with real continuity.',
    role: 'Faith',
    subtitle: 'Return to practice',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'aven-jp': {
    id: 'aven-jp',
    displayName: 'Aven',
    name: 'Aven',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '信仰の旅路に寄り添う。説教ではなく、共に在る。',
    voice: 'Grounded, gentle, real',
    social: '',
    color: '#60a5fa',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #000a1a 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Aven | 祈りと内面の実践を続けるAI | Leka AI',
    seoDescription: 'Aven は、祈り、内省、信仰実践に戻るための継続性をつくる AI です。説教ではなく、再入場しやすい伴走と faith-specific な深さを重視します。',
    seoKeywords: '祈り 継続, 内省 習慣, 信仰実践 再入場, 儀式 継続, spiritual continuity, Aven',
    bio: 'Aven は Leka の inner-life surface。祈り、内省、信仰実践に、日常の中で戻り続けるための継続性をつくる。',
    role: 'Faith',
    subtitle: '実践に戻る',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  'aven-evangelical': {
    id: 'aven-evangelical',
    displayName: 'Aven Evangelical',
    name: 'Aven Evangelical',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Returns to prayer, scripture, repentance, and daily walk with God.',
    voice: 'Warm, direct, scripture-shaped',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a1100 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Evangelical | Hidden Runtime Adapter | Leka AI',
    seoDescription: 'Hidden runtime adapter for Evangelical prayer and scripture continuity inside Aven.',
    seoKeywords: 'Aven Evangelical, hidden runtime adapter, Leka',
    bio: 'Runtime-only Evangelical Aven adapter for prayer, scripture continuity, repentance, and re-entry.',
    role: 'Faith',
    subtitle: 'Runtime adapter',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'aven-evangelical-jp': {
    id: 'aven-evangelical-jp',
    displayName: 'Aven Evangelical',
    name: 'Aven Evangelical',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '祈り、聖書、悔い改め、神との日々の歩みに戻る。',
    voice: 'Warm, direct, scripture-shaped',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a1100 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Evangelical | Hidden Runtime Adapter | Leka AI',
    seoDescription: 'Aven 内の福音派 runtime adapter。',
    seoKeywords: 'Aven Evangelical, hidden runtime adapter, Leka',
    bio: '祈り、聖書、悔い改め、再入場を支える runtime-only の Aven adapter。',
    role: 'Faith',
    subtitle: 'Runtime adapter',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  'aven-catholic': {
    id: 'aven-catholic',
    displayName: 'Aven Catholic',
    name: 'Aven Catholic',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Returns to prayer rhythm, examen, recollection, and sacramental preparation.',
    voice: 'Reverent, quiet, steady',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #0b1020 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Catholic | Hidden Runtime Adapter | Leka AI',
    seoDescription: 'Hidden runtime adapter for Catholic prayer rhythm and sacramental preparation inside Aven.',
    seoKeywords: 'Aven Catholic, hidden runtime adapter, Leka',
    bio: 'Runtime-only Catholic Aven adapter for prayer rhythm, examen, recollection, and re-entry.',
    role: 'Faith',
    subtitle: 'Runtime adapter',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'aven-catholic-jp': {
    id: 'aven-catholic-jp',
    displayName: 'Aven Catholic',
    name: 'Aven Catholic',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '祈りのリズム、良心の糾明、静かな回心、秘跡への備えに戻る。',
    voice: 'Reverent, quiet, steady',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #0b1020 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Catholic | Hidden Runtime Adapter | Leka AI',
    seoDescription: 'Aven 内のカトリック runtime adapter。',
    seoKeywords: 'Aven Catholic, hidden runtime adapter, Leka',
    bio: '祈りのリズム、良心の糾明、回心、再入場を支える runtime-only の Aven adapter。',
    role: 'Faith',
    subtitle: 'Runtime adapter',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  'aven-soka': {
    id: 'aven-soka',
    displayName: 'Aven Soka',
    name: 'Aven Soka',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Reconnects daimoku, determination, action, and proof in daily life through grounded practice continuity.',
    voice: 'Grounded, encouraging, action-linked',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0014 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Soka | Soka Practice Support on Aven | Leka AI',
    seoDescription: 'Aven Soka is Soka-facing practice support built on the shared Aven engine.',
    seoKeywords: 'Aven Soka, practice support, daimoku, continuity, Aven engine, Leka',
    bio: 'A thinner Soka-facing layer on top of Aven\'s shared engine, focused on continuity, restart, and one grounded next step.',
    role: 'Faith',
    subtitle: 'Practice support',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'aven-soka-jp': {
    id: 'aven-soka-jp',
    displayName: 'Aven Soka',
    name: 'Aven Soka',
    emoji: '🕊️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '題目、決意、行動、日常での実証を、地に足のついた継続支援でつなぎ直す。',
    voice: 'Grounded, encouraging, action-linked',
    social: '',
    color: '#d4af37',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0014 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Aven Soka | Aven engine ベースの創価向け実践支援 | Leka AI',
    seoDescription: 'Aven Soka は、shared Aven engine の上に載る創価向け practice support layer。',
    seoKeywords: 'Aven Soka, 創価, 実践支援, 題目, Aven engine, Leka',
    bio: 'Aven の shared engine の上に創価向けの言葉と guardrail を薄く載せた practice support layer。',
    role: 'Faith',
    subtitle: 'Practice support',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  mone: {
    id: 'mone',
    displayName: 'Mone',
    name: 'Mone',
    emoji: '💸',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Slows impulsive spending and helps you spend in line with what actually matters.',
    voice: 'Grounded, clear, non-shaming',
    social: '',
    color: '#22c55e',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #06190d 0%, #060a08 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Mone | Stop Impulse Spending and Reset Money Drift | Leka AI',
    seoDescription: 'Mone helps you stop impulse spending, do a spend reset, and make money decisions that match your values.',
    seoKeywords: 'impulse spending, spending reset, stop overspending, money habits, values aligned spending, Mone',
    bio: 'Not a spreadsheet. Not a guilt trip. Mone helps you slow down, spend on purpose, and reconnect money to the rest of your life.',
    role: 'Money',
    subtitle: 'Spend on purpose',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'mone-jp': {
    id: 'mone-jp',
    displayName: 'Mone',
    name: 'Mone',
    emoji: '💸',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '衝動買いを減速させ、支出を本当に大事なものに合わせ直す。',
    voice: 'Grounded, clear, non-shaming',
    social: '',
    color: '#22c55e',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #06190d 0%, #060a08 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Mone | 衝動買いと支出を立て直すAI | Leka AI',
    seoDescription: 'Mone は、衝動買い、使いすぎ、支出の乱れを止めて、価値観に沿ったお金の使い方へ戻す AI です。',
    seoKeywords: '衝動買い やめたい, 支出 リセット, 使いすぎ, 浪費, 家計立て直し, Mone',
    bio: '家計簿でも説教でもない。Mone は衝動を少し遅らせて、お金を何に使いたい人かを思い出させる。',
    role: 'Money',
    subtitle: 'お金を目的に沿って使う',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  teli: {
    id: 'teli',
    displayName: 'Teli',
    name: 'Teli',
    emoji: '📚',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Makes learning feel like progress, not obligation.',
    voice: 'Curious, encouraging, patient',
    social: '',
    color: '#34d399',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #001a0d 0%, #060a08 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Teli | Study and Exam Accountability AI | Leka AI',
    seoDescription: 'Teli helps you study consistently, restart after missed days, and handle exam pressure without drifting alone.',
    seoKeywords: 'study accountability AI, exam prep support, study consistency, restart studying, deadline pressure, Teli',
    bio: 'Language, skills, anything you want to learn — Teli keeps you showing up, and can help you study with one trusted partner.',
    role: 'Study',
    subtitle: 'Keep learning alive together',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'teli-jp': {
    id: 'teli-jp',
    displayName: 'Teli',
    name: 'Teli',
    emoji: '📚',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '学習を義務ではなく、進歩に変える。',
    voice: 'Curious, encouraging, patient',
    social: '',
    color: '#34d399',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #001a0d 0%, #060a08 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Teli | 試験勉強を続け直すAI | Leka AI',
    seoDescription: 'Teli は、試験勉強や資格勉強を続け、サボった後でも再開し、締切圧の中で前に進むための AI です。',
    seoKeywords: '試験勉強, 資格勉強, 勉強 続かない, 勉強 再開, 学習習慣, Teli',
    bio: '語学でも資格でも。勉強を「義務」じゃなく「前進」に変え、必要なら信頼できる1人と進められる。',
    role: 'Study',
    subtitle: '学びを一緒に続ける',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  movo: {
    id: 'movo',
    displayName: 'Movo',
    name: 'Movo',
    emoji: '💪',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Helps you lose weight without shame spirals or all-or-nothing resets.',
    voice: 'Calm, practical, encouraging',
    social: '',
    color: '#f43f5e',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0005 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Movo | Weight Loss Reset After a Slip | Leka AI',
    seoDescription: 'Movo helps you restart weight loss after overeating, binge episodes, and food drift without shame spirals.',
    seoKeywords: 'weight loss reset, binge recovery, overeating reset, diet restart, body accountability, Movo',
    bio: 'Weight loss, food, movement, routines — Movo helps you restart from the very next choice without guilt theatre.',
    role: 'Weight Loss',
    subtitle: 'Lose weight without spiraling',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'movo-jp': {
    id: 'movo-jp',
    displayName: 'Movo',
    name: 'Movo',
    emoji: '💪',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '罪悪感や全部ダメ思考に落ちず、減量を続けられる形に戻す。',
    voice: 'Calm, practical, encouraging',
    social: '',
    color: '#f43f5e',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a0005 0%, #0a0604 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoTitle: 'Movo | 食べすぎ後に立て直す減量AI | Leka AI',
    seoDescription: 'Movo は、食べすぎ、暴食、ダイエット崩れの後でも、罪悪感ループに落ちずに減量を立て直す AI です。',
    seoKeywords: '食べすぎ リセット, 暴食 立て直し, ダイエット 続かない, 減量 再開, 食事管理, Movo',
    bio: '減量、食事、運動、生活リズム。罪悪感のループに入らず、次の選択から立て直す。',
    role: 'Weight Loss',
    subtitle: '減量を続け直す',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  nilo: {
    id: 'nilo',
    displayName: 'Nilo',
    name: 'Nilo',
    emoji: '🌙',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Closes loops, softens night spirals, and helps you land the day.',
    voice: 'Calm, low-pressure, settling',
    social: '',
    color: '#818cf8',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #0a0f24 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Nilo | Reset Sleep Tonight | Leka AI',
    seoDescription: 'Nilo helps you reset sleep tonight, get out of the night spiral, and rebuild a bedtime routine that sticks.',
    seoKeywords: 'sleep reset tonight, bedtime routine AI, night spiral, insomnia support, revenge bedtime procrastination, Nilo',
    bio: 'When the day will not close and your mind keeps spinning, Nilo helps you land gently and reset the evening.',
    role: 'Sleep',
    subtitle: 'Land the day softly',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'nilo-jp': {
    id: 'nilo-jp',
    displayName: 'Nilo',
    name: 'Nilo',
    emoji: '🌙',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '夜のぐるぐるをほどいて、その日を静かに着地させる。',
    voice: 'Calm, low-pressure, settling',
    social: '',
    color: '#818cf8',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #0a0f24 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoTitle: 'Nilo | 今夜から睡眠を立て直すAI | Leka AI',
    seoDescription: 'Nilo は、今夜の睡眠を立て直し、夜の思考ループや夜更かしから抜けて、眠る流れを戻す AI です。',
    seoKeywords: '睡眠リセット, 夜更かし やめたい, 不眠, 夜の不安, 寝る前ルーティン, Nilo',
    bio: '終わらない夜に区切りを作る。閉じられないループをほどいて、静かに寝る側へ戻す。',
    role: 'Sleep',
    subtitle: '夜を静かに閉じる',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  zelo: {
    id: 'zelo',
    displayName: 'Zelo',
    name: 'Zelo',
    emoji: '⚡️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Pushes through chaos and deadline pressure.',
    voice: 'High-energy, urgent, focused',
    social: '',
    color: '#eab308',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a1200 0%, #0a0804 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Zelo — sprint execution energy, now frozen as its function gets absorbed elsewhere.',
    bio: 'Deadline energy remains useful, but the standalone sprint surface is frozen for now.',
    role: 'Sprint',
    subtitle: 'Frozen for now',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'zelo-jp': {
    id: 'zelo-jp',
    displayName: 'Zelo',
    name: 'Zelo',
    emoji: '⚡️',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: '混沌と締切圧の中で前に押し出す。',
    voice: 'High-energy, urgent, focused',
    social: '',
    color: '#eab308',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #1a1200 0%, #0a0804 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Zelo — 締切突破の役割は残すが、独立surfaceとしては freeze。',
    bio: 'スプリントの機能は他verticalへ吸収。Zelo自体は今は凍結。',
    role: 'Sprint',
    subtitle: 'いったん凍結',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  lumi: {
    id: 'lumi',
    displayName: 'Lumi',
    name: 'Lumi',
    emoji: '🔮',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'A softer, magical entry point into the Leka world.',
    voice: 'Soft, mysterious, playful',
    social: '',
    color: '#22d3ee',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #00151a 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Lumi — a future funnel surface, retained but frozen from the current public launch.',
    bio: 'Lumi stays in the codebase for future funnel experiments, but is not part of the active public lineup.',
    role: 'Fortune',
    subtitle: 'Frozen for now',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'lumi-jp': {
    id: 'lumi-jp',
    displayName: 'Lumi',
    name: 'Lumi',
    emoji: '🔮',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Lekaへの入口になる、やわらかく少し魔法っぽい存在。',
    voice: 'Soft, mysterious, playful',
    social: '',
    color: '#22d3ee',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #00151a 0%, #060608 70%)',
    imgPosition: '50% 20%',
    available: false,
    seoDescription: 'Lumi — 将来のfunnel候補として残すが、現行公開 lineup からは外す。',
    bio: 'Lekaへの入口としての価値は残るが、今の公開面では凍結。',
    role: 'Fortune',
    subtitle: 'いったん凍結',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
  mira: {
    id: 'mira',
    displayName: 'Mira',
    name: 'Mira',
    emoji: '🧭',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'A calm onboarding host who finds the right first room inside Leka.',
    voice: 'Clear, observant, lightly reassuring',
    social: '',
    color: '#7dd3fc',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #071a24 0%, #06080c 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoDescription: 'Mira — the onboarding host for Leka. Find the right first surface and start with less confusion.',
    bio: 'Mira is not a seventh surface. She helps you find the best first place to start, then hands you off clearly.',
    role: 'Onboarding',
    subtitle: 'Find your first route',
    fixedLanguage: 'en',
    imageOverride: SHARED_IMG,
    ogImage: OG_SHARED,
  },
  'mira-jp': {
    id: 'mira-jp',
    displayName: 'Mira',
    name: 'Mira',
    emoji: '🧭',
    tier: 1,
    ethnicity: 'Unknown',
    gender: 'unknown',
    personality: 'Leka 全体の入口を案内する、静かで判断の速い host。',
    voice: '明快, 落ち着き, さりげない安心感',
    social: '',
    color: '#7dd3fc',
    bgGradient: 'radial-gradient(ellipse at 50% 0%, #071a24 0%, #06080c 70%)',
    imgPosition: '50% 20%',
    available: true,
    seoDescription: 'Mira — Leka の onboarding host。最初に入るべき surface を見つける。',
    bio: 'Mira は7つ目の surface ではない。今の詰まり方を見て、最初に入るべき場所へ案内する。',
    role: 'Onboarding',
    subtitle: '最初の入口を見つける',
    fixedLanguage: 'ja',
    imageOverride: SHARED_IMG,
    ogImage: OG_JP,
  },
}
